import { getMeasurementStartTime, measureTimespanInSecs, ActivitySource, sendActivityMetricsToDatadog, } from '@goodhabitz/learning-activity-communication';
export class ActivityMetrics {
    constructor(token, debugMode = false) {
        this.activityId = '';
        this.activityMeasurementStartTime = 0;
        this.token = token;
        this.debugMode = debugMode;
    }
    isTheSameActivity(targetActivityId) {
        return `G_${this.activityId}`.includes(targetActivityId);
    }
    static getInstance(token, debugMode = false) {
        if (!this.instance) {
            this.instance = new ActivityMetrics(token, debugMode);
        }
        return this.instance;
    }
    onStartActivity(targetActivityId) {
        this.activityId = targetActivityId;
        this.activityMeasurementStartTime = getMeasurementStartTime();
        if (this.debugMode) {
            console.group('Activity start measurement');
            console.log(`Activity started at ${this.activityMeasurementStartTime}`);
        }
    }
    onInitializeActivity(targetActivityId) {
        if (!this.isTheSameActivity(targetActivityId))
            return;
        const activityInitializedTime = Date.now();
        const timeSpendInSeconds = measureTimespanInSecs(this.activityMeasurementStartTime, activityInitializedTime);
        const activityMetrics = {
            id: this.activityId,
            source: ActivitySource.GHCC,
            timeSpendInSeconds,
        };
        sendActivityMetricsToDatadog(this.token, activityMetrics);
        if (this.debugMode) {
            console.log(`Activity opened at ${activityInitializedTime}`);
            console.log(`${timeSpendInSeconds} seconds spent on waiting`);
            console.groupEnd();
        }
    }
    onTerminateActivity(targetActivityId) {
        if (!this.isTheSameActivity(targetActivityId))
            return;
        this.activityId = '';
        this.activityMeasurementStartTime = 0;
        if (this.debugMode) {
            console.log('Activity terminated');
        }
    }
}
ActivityMetrics.instance = null;
//# sourceMappingURL=activityMetrics.js.map